import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService {
  private router = inject(Router);

  private readonly LAST_URL_KEY = 'last_url';

  private ignoredRoutes = [
    '/',
    '/login',
    '/signup',
    '/reset-password',
  ];

  startTracking(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.urlAfterRedirects;

        if (this.shouldIgnore(url)) return;

        localStorage.setItem(this.LAST_URL_KEY, url);
      });
  }

  getLastUrl(): string {
    const lastUrl = localStorage.getItem(this.LAST_URL_KEY);

    if (!lastUrl || this.shouldIgnore(lastUrl)) {
      return '/dashboard';
    }

    return lastUrl;
  }

  clear(): void {
    localStorage.removeItem(this.LAST_URL_KEY);
  }

  private shouldIgnore(url: string): boolean {
    return this.ignoredRoutes.some(
      (route) => url === route || url.startsWith(route + '?')
    );
  }
}